import { defineMessage } from 'services/localization';

export const messages = {
    msgRequestsStartOverSuccess: defineMessage('selected_requests_will___may_take_a_few_moments'),
};
